<template>
  <div>
    <div class="vx-row mt-6">
      <div class="vx-col">
        <p>Local do evento</p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CEP"
          v-mask="'##.###-###'"
          v-model="form.cep"
          name="CEP"
          @keyup.native="keymonitor"
          v-validate="{ required: true, min: 10 }"
          :state="validateState('CEP')"
          :danger="validateClass('CEP')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Endereço"
          v-model="form.endereco"
          name="Endereço"
          v-validate="{ required: true }"
          :state="validateState('Endereço')"
          :danger="validateClass('Endereço')"
        />
      </div>
      <div class="vx-col sm:w-1/6 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número"
          type="number"
          v-model="form.numero"
          name="Número"
          v-validate="{ required: true }"
          :state="validateState('Número')"
          :danger="validateClass('Número')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Complemento"
          v-model="form.complemento"
          name="Complemento"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Bairro"
          v-model="form.bairro"
          name="Bairro"
          v-validate="{ required: true }"
          :state="validateState('Bairro')"
          :danger="validateClass('Bairro')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Estado"
          v-model="form.estado"
          name="Estado"
          v-validate="{ required: true }"
          :state="validateState('Estado')"
          :danger="validateClass('Estado')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Cidade"
          v-model="form.cidade"
          name="Cidade"
          v-validate="{ required: true }"
          :state="validateState('Cidade')"
          :danger="validateClass('Cidade')"
        />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for class="vs-input--label">Local do acidente sinalizado?</label>
        <vs-switch v-model="form.localSinalizado" color="success">
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
      <div class="vx-col sm:w-2/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Sinalização do local do acidente"
          v-model="form.sinalizacao"
          name="Sinalização do local do acidenteo"
          v-validate="{ required: true }"
          :state="validateState('Sinalização do local do acidente')"
          :danger="validateClass('Sinalização do local do acidente')"
          :disabled="!form.localSinalizado"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <vs-textarea
          label="Observação sobre o local"
          v-model="form.observacaoLocal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../../services';
import locale from '../../../locale';
import { decryptData } from '../../../services/decryptData';

export default {
  props: ['dadosLocalEvento', 'formulario'],
  watch: {
    dadosLocalEvento() {
      this.preencheForm();
    },
  },
  components: {},
  data() {
    return {
      form: {
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        pais: null,
        localSinalizado: null,
        sinalizacao: null,
        observacaoLocal: null,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitor: function () {
      if (this.form.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.form.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.form.endereco = res.data.street;
            this.form.bairro = res.data.neighborhood;
            this.form.cidade = res.data.city;
            this.form.estado = res.data.state;
            this.form.pais = res.data.country;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      this.form.cep = this.dadosLocalEvento.cep;
      this.form.endereco = this.dadosLocalEvento.endereco;
      this.form.numero = this.dadosLocalEvento.numero;
      this.form.complemento = this.dadosLocalEvento.complemento;
      this.form.bairro = this.dadosLocalEvento.bairro;
      this.form.estado = this.dadosLocalEvento.estado;
      this.form.cidade = this.dadosLocalEvento.cidade;
      this.form.pais = this.dadosLocalEvento.pais;
    },
    emitForm() {
      this.$emit('formAlterado', this.form);
    },
  },
  mounted() {
    this.preencheForm();
    this.$validator.localize('ptBr', locale);
  },
  created: function () {
    this.$watch('form', this.emitForm, {
      deep: true,
    });
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
